import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const FormationService = {
  // Récupérer les matières avec leurs cours
  async getMatieres(studentId) {
    try {
      const result = await axios.get(`${apiUrl}/formation/matieres`, {
        params: { student_id: studentId }
      });
      return result.data;
    } catch (error) {
      console.error("Erreur dans getMatieres:", error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la récupération des matières",
        data: []
      };
    }
  },

  // Récupérer un cours spécifique
  async getCoursById(coursId) {
    try {
      const result = await axios.get(`${apiUrl}/formation/cours/${coursId}`);
      return result.data;
    } catch (error) {
      console.error("Erreur dans getCoursById:", error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la récupération du cours",
        data: null
      };
    }
  },

  // Récupérer l'URL du fichier d'un cours
  getFileUrl(coursId) {
    return `${apiUrl}/formation/cours/file/${coursId}`;
  },

  // Récupérer les questions d'un cours
  async getQuestionsByCours(coursId) {
    try {
      const result = await axios.get(`${apiUrl}/formation/questions`, {
        params: { cours_id: coursId }
      });
      return result.data;
    } catch (error) {
      console.error("Erreur dans getQuestionsByCours:", error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la récupération des questions",
        data: []
      };
    }
  },

  // Soumettre un résultat QCM
  async submitQcmResult(data) {
    try {
      const result = await axios.post(`${apiUrl}/formation/submit-qcm`, data);
      return result.data;
    } catch (error) {
      console.error("Erreur dans submitQcmResult:", error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de l'enregistrement du résultat",
        data: null
      };
    }
  },

  // Récupérer tous les résultats d'un étudiant
  async getResults(studentId) {
    try {
      const result = await axios.get(`${apiUrl}/formation/results`, {
        params: { student_id: studentId }
      });
      return result.data;
    } catch (error) {
      console.error("Erreur dans getResults:", error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la récupération des résultats",
        data: { results: [], stats: {} }
      };
    }
  }
};

export default FormationService;